import { faCircleMinus, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import { SetState } from 'src/types/generic';

interface AccordionProps {
  title: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  error?: boolean;
  expandAlways?: boolean;
  controlled?: boolean;
  expanded?: boolean;
  setExpanded?: SetState<boolean>;
}

const Accordion: FC<AccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
  error = false,
  expandAlways = false,
  controlled = false,
  expanded: controlledExpanded = controlled ? defaultExpanded : undefined,
  setExpanded: controlledSetExpanded,
}) => {
  const [_expanded, _setExpanded] = useState(defaultExpanded);
  const expanded = controlled ? controlledExpanded : _expanded;
  const setExpanded = controlled ? controlledSetExpanded : _setExpanded;

  const toggleExpanded = useCallback(
    () => !expandAlways && setExpanded?.((prev) => !prev),
    [expandAlways, setExpanded]
  );
  useEffect(() => {
    setExpanded?.(defaultExpanded);
  }, [defaultExpanded, setExpanded]);

  return (
    <div
      className={`${error ? 'border-error border-4' : 'border-disabled border-2'}  rounded-lg  `}
    >
      <div
        className="select-none flex flex-row items-center rounded-sm gap-2 cursor-pointer bg-[#676767] py-3 px-4"
        onClick={toggleExpanded}
      >
        {expandAlways ? (
          ''
        ) : (
          <div>
            {expanded ? (
              <FontAwesomeIcon icon={faCircleMinus} color="white" size="lg" />
            ) : (
              <FontAwesomeIcon icon={faCirclePlus} color="white" size="lg" />
            )}
          </div>
        )}
        <h5 className="flex-1 text-base font-semibold text-white ">{title}</h5>
      </div>
      <div
        className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
          expanded ? 'max-h-[1100px]' : 'max-h-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
